/* eslint-disable */
import React from "react";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const DoctorDetailsCard = ({ doctor = {} }) => {
  return (
    <div className="patient-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
      <div className="d-flex gap-3">
        <div
          className="avatar rounded-circle overflow-hidden"
          style={{
            width: "60px",
            height: "60px",
          }}
        >
          <img
            className="w-100 h-100 object-fit-cover"
            src={
              doctor?.image !== ""
                ? url.SERVER_URL + doctor?.image
                : assetImages.defaultUser
            }
            alt="patient"
          />
        </div>
        <div>
          <p className="mb-0">{doctor?.label}</p>
          <p className="font-sm text-gray mb-1">
            Doctor Email: {doctor?.email}
          </p>
        </div>
      </div>
      <div className="contact-info pt-3 border-top border-gray-100 mt-3">
        <p className="fw-semibold mb-2">Information for {doctor?.label}</p>
        <p className="font-sm text-gray mb-1">Phone: {doctor?.phone}</p>
        <p className="font-sm text-gray mb-1">City: {doctor?.city}</p>
        <p className="font-sm text-gray mb-1">State: {doctor?.state}</p>
        <p className="font-sm text-gray mb-1">Country: {doctor?.country}</p>
      </div>
    </div>
  );
};

export default DoctorDetailsCard;
